import React from "react"
import { ScrollReveal } from "../ui/scroll-reveal"
import { Button } from "../ui/button"
import { Link, useLocation } from "react-router-dom"
import { EventCategory } from "../../lib/analytics"
import { safeTrackEvent } from "../../lib/analytics-utils"
import { cn } from "../../lib/utils"

export function CtaSection() {
  const location = useLocation();
  const pageName = location.pathname === "/" ? "home" : location.pathname.replace(/^\/|\/$/g, '').replace(/\//g, '_');
  
  const handleCtaClick = () => {
    safeTrackEvent({
      category: EventCategory.Engagement,
      label: `engagement_${pageName}_schedule_consultation`,
      context: {
        sourcePage: location.pathname,
        destinationPage: '/contact',
        section: 'main_cta'
      }
    });
  };
  
  return (
    <section className="py-20 pb-32">
      <div className="container">
        <ScrollReveal>
          <div className="max-w-3xl mx-auto text-center space-y-8 bg-primary/5 rounded-xl p-10 border border-primary/10">
            <h2 className="text-3xl font-bold">Ready to Meet the Team?</h2>
            <p className="text-xl text-muted-foreground">
              Contact us today to discover how our expert consultants can accelerate your AI-driven innovation.
            </p>
            <div className="pt-4">
              <Button 
                asChild 
                size="lg" 
                className="text-lg px-10"
                onClick={handleCtaClick}
              >
                <Link to="/contact">Let's Talk</Link>
              </Button>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  )
}

export function ContactCtaSection({ 
  className,
  spacingClass = "py-20" 
}: { 
  className?: string;
  spacingClass?: string;
}) {
  const location = useLocation();
  const pageName = location.pathname === "/" ? "home" : location.pathname.replace(/^\/|\/$/g, '').replace(/\//g, '_');
  
  const handleCtaClick = () => {
    safeTrackEvent({
      category: EventCategory.Engagement,
      label: `engagement_${pageName}_get_started`,
      context: {
        sourcePage: location.pathname,
        destinationPage: '/contact',
        section: 'contact_cta'
      }
    });
  };
  
  return (
    <section className={spacingClass}>
      <div className="container">
        <ScrollReveal>
          <div className={
            className !== undefined ? 
              cn("max-w-3xl mx-auto text-center space-y-8 p-10", className) : 
              "max-w-3xl mx-auto text-center space-y-8 p-10 bg-primary/5 rounded-xl border border-primary/10"
          }>
            <h2 className="text-3xl font-bold">Ready to Get Started?</h2>
            <p className="text-xl text-muted-foreground">
              Contact us today to discover how our expert consultants can accelerate your AI-driven innovation.
            </p>
            <div className="pt-4">
              <Button 
                asChild 
                size="lg" 
                className="text-lg px-10"
                onClick={handleCtaClick}
              >
                <Link to="/contact">Schedule a Consultation</Link>
              </Button>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  )
}

export function HorizontalCtaSection() {
  const location = useLocation();
  const pageName = location.pathname === "/" ? "home" : location.pathname.replace(/^\/|\/$/g, '').replace(/\//g, '_');
  
  const handleCtaClick = () => {
    safeTrackEvent({
      category: EventCategory.Engagement,
      label: `engagement_${pageName}_meet_team`,
      context: {
        sourcePage: location.pathname,
        destinationPage: '/meet-the-team',
        section: 'horizontal_cta'
      }
    });
  };
  
  return (
    <section className="py-16 mt-4 mb-4 bg-primary/5 border-y border-primary/10">
      <div className="container">
        <ScrollReveal>
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
            <div className="space-y-2">
              <h2 className="text-2xl md:text-3xl font-bold">Ready to Meet the Team?</h2>
              <p className="text-lg text-muted-foreground">
                Discover how our expert consultants can accelerate your AI-driven innovation.
              </p>
            </div>
            <Button 
              asChild 
              size="lg" 
              className="text-lg px-10 whitespace-nowrap"
              onClick={handleCtaClick}
            >
              <Link to="/meet-the-team">Let's Talk</Link>
            </Button>
          </div>
        </ScrollReveal>
      </div>
    </section>
  )
} 